// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IAssessmentRelevantProofApi,
  IAssessmentRelevantProofApiRequest,
  IAssessmentRelevantProofApiGetListAttrs,
  IAssessmentRelevantProofApiListResponse,
  IAssessmentRelevantProofApiDownloadDocumentAttrs,
  IAssessmentRelevantProofApiDownloadDocumentResponse,
} from 'interfaces/back-office/assessment/registration/relevant-proof/relevant-proof-api.interface'

// Constant
import { ApiConstantHc, ApiConstantHcBase } from 'constant'

// Utils
import { axios_renderHcUrl } from 'utils'

export class AssessmentRelevantProofApi
  extends BaseApi<IAssessmentRelevantProofApi>
  implements IAssessmentRelevantProofApiRequest
{
  readonly url = ApiConstantHc.ASSESSMENT_REGISTRATION_RELEVANT_PROOF_URL
  private assessmentRegistrationRelevantProofUrl = axios_renderHcUrl(this.url, ApiConstantHcBase.ASSESSMENT)

  /**
   * @description Get assessment relevant proof list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentRelevantProofApiGetListAttrs} payload
   *
   * @return {Promise<IAssessmentRelevantProofApiListResponse>} Promise<IAssessmentRelevantProofApiListResponse>
   */
  async assessmentRelevantProof_getList(
    payload: IAssessmentRelevantProofApiGetListAttrs,
  ): Promise<IAssessmentRelevantProofApiListResponse> {
    return this.POST(
      `${this.assessmentRegistrationRelevantProofUrl}/list/${payload.params.assessmentId}`,
      {},
      { ...payload.requestConfig },
    )
  }

  /**
   * @description Download assessment relevant proof document
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentRelevantProofApiDownloadDocumentAttrs} payload
   *
   * @return {Promise<IAssessmentRelevantProofApiDownloadDocumentResponse>} Promise<IAssessmentRelevantProofApiDownloadDocumentResponse>
   */
  async assessmentRelevantProof_downloadDocument(
    payload: IAssessmentRelevantProofApiDownloadDocumentAttrs,
  ): Promise<IAssessmentRelevantProofApiDownloadDocumentResponse> {
    return this.POST(
      `${this.assessmentRegistrationRelevantProofUrl}/download/${payload.params.blobId}`,
      {},
      { ...payload.requestConfig, responseType: 'blob' },
    )
  }
}
